import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocx = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_441_10921)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 1.39683V14.6032C4 15.3746 4.61561 16 5.375 16H14.625C15.3844 16 16 15.3746 16 14.6032V3.67563C16 3.30251 15.8531 2.9449 15.5919 2.68251L13.3239 0.403706C13.0665 0.145065 12.7191 0 12.357 0H5.375C4.61561 0 4 0.62538 4 1.39683ZM4.875 14.6032V1.39683C4.875 1.1163 5.09886 0.888889 5.375 0.888889H12.1875V3.93651C12.1875 4.46249 12.6072 4.88889 13.125 4.88889H15.125V14.6032C15.125 14.8837 14.9011 15.1111 14.625 15.1111H5.375C5.09886 15.1111 4.875 14.8837 4.875 14.6032ZM15.125 4V3.67563C15.125 3.53995 15.0716 3.40991 14.9766 3.3145L13.0625 1.39127V3.93651C13.0625 3.97157 13.0905 4 13.125 4H15.125Z",
				fill: "#9D9C9B"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.25 6.5625C10.25 6.32088 10.4459 6.125 10.6875 6.125H13.5625C13.8041 6.125 14 6.32088 14 6.5625C14 6.80412 13.8041 7 13.5625 7H10.6875C10.4459 7 10.25 6.80412 10.25 6.5625Z",
				fill: "#6BB3EC"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.25 8.5625C10.25 8.32088 10.4459 8.125 10.6875 8.125H13.5625C13.8041 8.125 14 8.32088 14 8.5625C14 8.80412 13.8041 9 13.5625 9H10.6875C10.4459 9 10.25 8.80412 10.25 8.5625Z",
				fill: "#508FD6"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.25 10.5625C10.25 10.3209 10.4459 10.125 10.6875 10.125H13.5625C13.8041 10.125 14 10.3209 14 10.5625C14 10.8041 13.8041 11 13.5625 11H10.6875C10.4459 11 10.25 10.8041 10.25 10.5625Z",
				fill: "#3770C3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4.625C0 4.21079 0.335786 3.875 0.75 3.875H8.25C8.66421 3.875 9 4.21079 9 4.625V12.125C9 12.5392 8.66421 12.875 8.25 12.875H0.75C0.335786 12.875 0 12.5392 0 12.125V4.625Z",
				fill: "#3770C3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.73096 10.7607L1.75 5.75H2.60107L3.21631 9.19189L3.96826 5.75H4.95605L5.67725 9.25L6.30957 5.75H7.14355L6.14551 10.7607H5.26367L4.44336 7.01465L3.62988 10.7607H2.73096Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_441_10921",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDocx;
